import { CHANGE_ACTIVE_INPUT, SET_STATUSID_TRIP } from './constants';

export const changeActiveInput = (name: string = '') => ({
  type: CHANGE_ACTIVE_INPUT,
  payload: name,
});

export const setStatusIDTrip = (statusId: number = 0) => ({
  type: SET_STATUSID_TRIP,
  payload: statusId,
});

export type Actions = ReturnType<typeof changeActiveInput> | ReturnType<typeof setStatusIDTrip>;
